export default __webpack_public_path__ + "mobile_03-626419fc0ee9df8f6eedd34bd98a17db.jpg";